import { CollabsibleContainer } from "@plugins";

const filterColorsContainer = document.querySelector(".js-filter-color-collapsing-init");

function initCollapsibleColors() {
    if (filterColorsContainer) {
        if (window.mobileMedia) {
            new CollabsibleContainer(filterColorsContainer, {
                buttonClasses: "filter-color__more btn-more js-filter-more",
                collapsibleItemsClass: "js-filter-color-item",
                limiter: 16,
            });
        } else {
            new CollabsibleContainer(filterColorsContainer, {
                buttonClasses: "filter-color__more btn-more js-filter-more",
                collapsibleItemsClass: "js-filter-color-item",
                limiter: 21,
            });
        }
    }
}

window.addEventListener("load", () => initCollapsibleColors());
